/**
 * WHAT A RECURRING QUEST'S BAND SAYS ABOUT ITS PERIOD (#4118, Nick, 8 Oct): "Every week ·
 * resets Monday". A recurring quest comes round again once its period is done, and
 * without this the band read exactly like a one-off.
 *
 * `periodEndsAt` is midnight at the start of the next period in the member's own zone, as
 * the API computes it. Pass that same zone as `timeZone`: the caption names the weekday or
 * date in the viewer's locale and the member's zone. The runtime zone can be the previous
 * day — a UTC Monday midnight is still Sunday evening across the Americas. Returns null
 * for a one-off quest, or a title with an empty caption when the period end is missing
 * or unreadable.
 */
export type PeriodLabel = { title: string; caption: string };

const TITLE: Record<string, string> = { daily: 'Every day', weekly: 'Every week', monthly: 'Every month' };

export function recurringPeriodLabel(
  cadence: string,
  periodEndsAt: string | null,
  locale?: string,
  timeZone?: string
): PeriodLabel | null {
  const title = TITLE[cadence];
  if (!title) return null;
  if (cadence === 'daily') return { title, caption: 'resets at midnight' };
  if (!periodEndsAt) return { title, caption: '' };
  const ends = new Date(periodEndsAt);
  if (Number.isNaN(ends.getTime())) return { title, caption: '' };
  const options: Intl.DateTimeFormatOptions =
    cadence === 'weekly' ? { weekday: 'long', timeZone } : { month: 'short', day: 'numeric', timeZone };
  return { title, caption: `resets ${ends.toLocaleDateString(locale, options)}` };
}
